import { commonBoolean as enCommonBoolean } from "./i18n/features/en/common-boolean";
import { commonFields as enCommonFields } from "./i18n/features/en/common-fields";
import { commonIdentityPicker as enCommonIdentityPicker } from "./i18n/features/en/common-identity-picker";
import { commonLabels as enCommonLabels } from "./i18n/features/en/common-labels";
import { commonNouns as enCommonNouns } from "./i18n/features/en/common-nouns";
import { commonSecurity as enCommonSecurity } from "./i18n/features/en/common-security";
import { commonBoolean as jaCommonBoolean } from "./i18n/features/ja/common-boolean";
import { commonFields as jaCommonFields } from "./i18n/features/ja/common-fields";
import { commonIdentityPicker as jaCommonIdentityPicker } from "./i18n/features/ja/common-identity-picker";
import { commonLabels as jaCommonLabels } from "./i18n/features/ja/common-labels";
import { commonNouns as jaCommonNouns } from "./i18n/features/ja/common-nouns";
import { commonSecurity as jaCommonSecurity } from "./i18n/features/ja/common-security";
import { commonBoolean as zhCommonBoolean } from "./i18n/features/zh/common-boolean";
import { commonFields as zhCommonFields } from "./i18n/features/zh/common-fields";
import { commonIdentityPicker as zhCommonIdentityPicker } from "./i18n/features/zh/common-identity-picker";
import { commonLabels as zhCommonLabels } from "./i18n/features/zh/common-labels";
import { commonNouns as zhCommonNouns } from "./i18n/features/zh/common-nouns";
import { commonSecurity as zhCommonSecurity } from "./i18n/features/zh/common-security";
import {
  DEFAULT_LOCALE,
  getLocale as sharedGetLocale,
  normalizeLocale,
  setLocale as sharedSetLocale,
  subscribeLocaleChange as sharedSubscribeLocaleChange,
} from "./i18n/locale-state";
import { createI18nRuntime } from "./i18n/runtime";

export type { AppLocale } from "./i18n/locale-state";
export { APP_LOCALE_LABELS, APP_LOCALES, DEFAULT_LOCALE, normalizeLocale } from "./i18n/locale-state";

const localeCatalogs = {
  "zh-CN": {
    common: {
      identityPicker: zhCommonIdentityPicker,
      fields: zhCommonFields,
      nouns: zhCommonNouns,
      labels: zhCommonLabels,
      security: zhCommonSecurity,
      boolean: zhCommonBoolean,
    },
  },
  en: {
    common: {
      identityPicker: enCommonIdentityPicker,
      fields: enCommonFields,
      nouns: enCommonNouns,
      labels: enCommonLabels,
      security: enCommonSecurity,
      boolean: enCommonBoolean,
    },
  },
  ja: {
    common: {
      identityPicker: jaCommonIdentityPicker,
      fields: jaCommonFields,
      nouns: jaCommonNouns,
      labels: jaCommonLabels,
      security: jaCommonSecurity,
      boolean: jaCommonBoolean,
    },
  },
} as const;

export const zhCN = localeCatalogs["zh-CN"];
export type Messages = typeof zhCN;

export const {
  messageCatalogs,
  setLocale,
  getLocale,
  subscribeLocaleChange,
  createMessageProxy,
  hasMessage,
  t,
  formatMessage,
  formatEnumPath,
  formatEnumLabel,
  formatBooleanLabel,
  formatLocalizedList,
  formatActionObjectLabel,
  formatActionObjectMessage,
  formatActionObjectIntlLabel,
} = createI18nRuntime({
  defaultLocale: DEFAULT_LOCALE,
  localeCatalogs,
  normalizeLocale,
  localeState: {
    getLocale: sharedGetLocale,
    setLocale: sharedSetLocale,
    subscribeLocaleChange: sharedSubscribeLocaleChange,
  },
});

export type {
  DeepPartialMessageTree,
  FormatMessageLike,
  MessageDescriptor,
  MessageParams,
  MessageTree,
} from "./i18n/runtime";
